module.exports = __webpack_public_path__ + "img/header-cloak.df31f821.png";